import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Pictogram from '../pictogram';
import RefundBreakdown from '../../../components/global/refund/refund-breakdown';
import { withWindow } from '../../../decorators/window';
import { getLocationIso } from '../../../utilities/interaction-studio-utilities';
import RefundConfirmationViewMobile from './refund-confirmation-mobile-view';
import TranslatedCopy from '../../../intl/translated-copy';
import useWizard from '../wizard/useWizard';
import { HomeE4 } from '../../../../routing/urls';
import { formatAmountWithDecimals } from '../../../../cms-wrapper/utils';
import PropTypes from 'prop-types';
import LoadingComponent from '../loading-component';
import RefundPenaltyChargePaid from './refund-penalty-charge-paid';

const RefundSuccessful = ({
  breakpointNewDesign,
  country,
  fulfillRefundData,
  language,
  optionSelected,
  refundInfoToSalesforce,
  specialRefund,
  stateStoreFront,
  storefront,
}) => {
  const { penaltyChargeCard } = useWizard();
  const { thereAreDTickets, nonRefundableExtrasExist } = useWizard();

  const isLarge = breakpointNewDesign === 'large';
  const isMediumOrMediumHigh = (breakpointNewDesign === 'medium' || breakpointNewDesign === 'medium-high');

  // Se hizo maquetado, actualmente no existe informacion real para asignar esto
  const showPoints = false;

  const currencyOfRefund = fulfillRefundData?.refunds?.[0]?.refundedItemAmount?.[0]?.currencyCode;

  const total = (fulfillRefundData?.refunds || []).reduce((sum, refund) => {
    const refundPax = refund?.refundedItemAmount?.reduce((refundPax, amount) => (refundPax + amount?.dAmount), 0);
    return sum + refundPax;
  }, 0);

  const numberOfDecimalsBE = stateStoreFront?.numberOfDecimalsBE != null ? stateStoreFront.numberOfDecimalsBE : 0;

  const { step } = useWizard();
  const cardNumbers = [];
  const cardNumbersContainsElement = (cardToSearch) => {
    return cardNumbers.some(cardItem =>
      cardItem?.cardType === cardToSearch?.cardType
      && cardItem?.card === cardToSearch?.card
    );
  };

  (fulfillRefundData?.refunds || []).forEach(refund => {
    (refund?.refundedItemAmount || []).forEach(refundedItem => {
      if (refund?.refunded && !cardNumbersContainsElement({ cardType: refundedItem?.refundedTo.slice(0, 2), card: refundedItem?.refundedTo.slice(-4) }) && cardNumbers.length < 2) {
        cardNumbers.push({ cardType: refundedItem?.refundedTo.slice(0, 2), card: refundedItem?.refundedTo.slice(-4) });
      }
    });
  });

  const options = {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  };
  const locale = getLocationIso(window?.location?.pathname?.split('/')?.[2]).replace('_', '-');
  const date = new Date().toLocaleDateString(locale, options);

  const [newTicketNumber, setNewTicketNumber] = useState(0);

  useEffect(() => {
    if (!refundInfoToSalesforce?.errorFromSalesforce && refundInfoToSalesforce?.messageServer?.casenumber !== '' && refundInfoToSalesforce?.messageServer?.casenumber !== undefined) {
      setNewTicketNumber(refundInfoToSalesforce?.messageServer?.casenumber);
    } else if (refundInfoToSalesforce?.errorFromSalesforce) {
      setNewTicketNumber('Error');
    }
  }, [refundInfoToSalesforce]);

  return (
    <Fragment>
      { (isMediumOrMediumHigh || isLarge) ?
        <div className='RefundSuccessful'>
          <div className='RefundSuccessful-headerWrapper'>
            <div className='RefundSuccessful-headerWrapper-titleSection'>
              <div className='RefundSuccessful-headerWrapper-titleSection-confirmation'>
                <Pictogram className='RefundSuccessful-headerWrapper-titleSection-confirmation--confirmationIcon' id='RefundSuccessful' />
                <TranslatedCopy
                  className='RefundSuccessful-headerWrapper-titleSection-confirmation--header'
                  copyID='MYB_REFUND_APPLIED'
                  tagName='p'
                />
              </div>
              <Pictogram
                onClick={ () => window.print() }
                className='RefundSuccessful-headerWrapper--printIcon'
                id='PrintIcon'
              />
            </div>
          </div>
          <div className='RefundSuccessful-confirmationDetails'>
            <div className='RefundSuccessful-confirmationDetails-wrapper'>
              <div className='RefundSuccessful-confirmationDetails-wrapper-accountDetails'>
                <TranslatedCopy
                  className='RefundSuccessful-confirmationDetails-wrapper-accountDetails--breakdownTitle'
                  copyID='MYB_REFUND_TO_CLIENT'
                  tagName='p'
                />
                <div className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-dateWrapper'>
                  <Pictogram className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-dateWrapper--calenderIcon' id='CalenderIcon' />
                  <p className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-dateWrapper--date'>{ date }</p>
                </div>
                { (optionSelected === 'AW' || showPoints) &&
                  <>
                    <div className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-accountAndIcon'>
                      <Pictogram
                        className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-accountAndIcon-icon'
                        id='AerowalletWhiteBackground'
                      />
                      <p className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-accountAndIcon-name'>
                      </p>
                    </div>
                    <div className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-preBalanceWrapper'>
                      <TranslatedCopy
                        className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-preBalanceWrapper--title'
                        copyID='MYB_PREVIOUS_BALANCE'
                        tagName='p'
                      />
                      <div className='RefundSuccessful-preBalanceWrapper-totalAmount'>
                        <span className='RefundSuccessful-preBalanceWrapper-totalAmount--value'>{'0 '}</span>
                        <span className='RefundSuccessful-preBalanceWrapper-totalAmount--currency'>
                          <TranslatedCopy
                            className=''
                            copyID='MYB_POINTS_SELECT'
                          />
                        </span>
                      </div>
                    </div>
                    <div className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-postBalanceWrapper'>
                      <TranslatedCopy
                        className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-postBalanceWrapper--title'
                        copyID='MYB_BALANCE_REFUNDED'
                        tagName='p'
                      />
                      <div className='RefundSuccessful-postBalanceWrapper-totalAmount'>
                        <span className='RefundSuccessful-postBalanceWrapper-totalAmount--value'>{'0 '}</span>
                        <span className='RefundSuccessful-postBalanceWrapper-totalAmount--currency'>
                          <TranslatedCopy
                            className=''
                            copyID='MYB_POINTS_SELECT'
                          />
                        </span>
                      </div>
                    </div>
                    <div className='RefundSuccessful-confirmationDetails-wrapper-accountDetails--horizontalLine' />
                  </>
                }
                { optionSelected === 'Card' &&
                  <>
                    <div className='RefundSuccessful-confirmationDetails-wrapper-accountDetails-refundedAmountDetails'>
                      <div className='RefundSuccessful-refundedAmountDetails-refundedCardDetails'>
                        { cardNumbers.map((cardNumber, index) => (
                          <Fragment key={ index }>
                            { cardNumber?.cardType === 'VI' &&
                              <Pictogram id='Visa' className='RefundSuccessful-refundedAmountDetails-refundedCardDetails--cardLogo' />
                            }
                            { cardNumber?.cardType === 'CA' &&
                              <Pictogram id='Mastercard' className='RefundSuccessful-refundedAmountDetails-refundedCardDetails--cardLogo' />
                            }
                            { cardNumber?.cardType === 'AX' &&
                              <Pictogram id='Amex' className='RefundSuccessful-refundedAmountDetails-refundedCardDetails--amexLogo' />
                            }
                            <p className='RefundSuccessful-refundedAmountDetails-refundedCardDetails--cardDetails'><TranslatedCopy copyID='MYB_CARD' />{ ` **** ${ cardNumber?.card }` }</p>
                          </Fragment>
                        ))}
                      </div>
                      <div className='RefundSuccessful-refundedAmountDetails-refundDetails'>
                        <TranslatedCopy
                          className='RefundSuccessful-refundedAmountDetails-refundDetails--header'
                          copyID='MYB_BALANCE_REFUNDED'
                          tagName='p'
                        />
                        <div className='RefundSuccessful-refundedAmountDetails-refundDetails-valueDetails'>
                          <p className='RefundSuccessful-refundedAmountDetails-refundDetails-valueDetails--amount'>
                            { `$${ formatAmountWithDecimals(total, numberOfDecimalsBE) }` }
                          </p>
                          <p className='RefundSuccessful-refundedAmountDetails-refundDetails-valueDetails--currency'>{ currencyOfRefund }</p>
                        </div>
                      </div>
                    </div>
                    <div className='RefundSuccessful-confirmationDetails-wrapper-accountDetails--horizontalLine' />
                    { showPoints &&
                      <TranslatedCopy
                        className='RefundSuccessful-confirmationDetails-wrapper-accountDetails--note'
                        copyID='MYB_USE_YOUR_BALANCE'
                        tagName='p'
                      />
                    }
                    <TranslatedCopy
                      className='RefundSuccessful-confirmationDetails-wrapper-accountDetails--note'
                      copyID='MYB_REFUND_WILL_BE_REFLECTED_IN_DAYS'
                      tagName='p'
                    />
                  </>
                }
              </div>
              <div className='RefundSuccessful-confirmationDetails-wrapper--partitionLine' />
              { optionSelected === 'Card' ?
                <div className='RefundSuccessful-confirmationDetails-wrapper-breakdown'>
                  <RefundBreakdown confirmation={ step === 2 } />
                </div>
                :
                <div className='RefundSuccessful-confirmationDetails-wrapper-awReview'>
                  <TranslatedCopy
                    className='RefundSuccessful-confirmationDetails-wrapper-awReview--balanceNote'
                    tagName='p'
                    copyID='MYB_USE_YOUR_BALANCE'
                  />
                  <div className='RefundSuccessful-confirmationDetails-wrapper-awReview-totalRefund'>
                    <TranslatedCopy
                      className='RefundSuccessful-confirmationDetails-wrapper-awReview-totalRefund--title'
                      copyID='MYB_TOTAL_REFUNDED'
                      tagName='p'
                    />
                    <div className='RefundSuccessful-totalRefund-balance'>
                      <p className='RefundSuccessful-totalRefund-balance--value'>
                        { `$${ formatAmountWithDecimals(total, numberOfDecimalsBE) }` }
                      </p>
                      <p className='RefundSuccessful-totalRefund-balance--currency'>{ currencyOfRefund }</p>
                    </div>
                  </div>
                  <TranslatedCopy
                    className='RefundSuccessful-confirmationDetails-wrapper-awReview--taxNote'
                    copyID='MYB_TAXES_INCLUDED'
                    tagName='p' />
                  <div className='RefundSuccessful-confirmationDetails-wrapper-awReview-taxVat'>
                    <TranslatedCopy
                      className='RefundSuccessful-confirmationDetails-wrapper-awReview-taxVat--taxNote'
                      copyID='MYB_VALUE_ADDED_TAX'
                      tagName='p' />
                    <p className='RefundSuccessful-confirmationDetails-wrapper-awReview-taxVat--taxAmt'>$934.00</p>
                  </div>
                </div>
              }
            </div>
            { nonRefundableExtrasExist && 
              <div className='RefundSuccessful-confirmationDetails-extras'>
                <Pictogram id='Clock' className='RefundSuccessful-confirmationDetails-extras--extrasIcon'/>
                <TranslatedCopy
                  className='RefundSuccessful-confirmationDetails-extras--ticketTitle'
                  copyID='MYB_PENDING_EXTRAS_EXIST'
                  tagName='p'
                />
                { refundInfoToSalesforce?.loading ?
                  <LoadingComponent
                    className='RefundSuccessful-confirmationDetails-extras-miniLoader'
                    refunds = { true }
                  />
                  :
                  <>
                    { newTicketNumber !== 'Error' ?
                      <div className='RefundSuccessful-confirmationDetails-extras-ticketNumberContainer'>
                        <TranslatedCopy
                          className='RefundSuccessful-confirmationDetails-extras-ticketNumberContainer--ticketTitle'
                          copyID='MYB_TICKET'
                          tagName='p'
                        />
                        <p className='RefundSuccessful-confirmationDetails-extras-ticketNumberContainer--ticketText'>{ newTicketNumber }</p>
                      </div>
                      :
                      <TranslatedCopy
                        className='RefundSuccessful-confirmationDetails-extras--errorMessage'
                        copyID='MYB_THERE_WAS_AN_ERROR_NON_REFUNDABLE'
                        tagName='a'
                        onClick={ () => specialRefund(storefront, 'Reembolso no procesado ram') }
                      />
                    }
                  </>
                }
              </div>
            }
            { penaltyChargeCard &&
              <RefundPenaltyChargePaid />
            }
            { thereAreDTickets ?
              <div className='RefundSuccessful-confirmationDetails-refundSuccessBottomSelection'>
                <TranslatedCopy
                  className='RefundSuccessful-confirmationDetails-refundSuccessBottomSelection--text'
                  copyID='MYB_THE_TICKETS_HAVE_BEEN_REFUNDED'
                />
                <div className='RefundSuccessful-confirmationDetails-refundSuccessBottomSelection-buttonSelection'>
                  <TranslatedCopy
                    className='RefundSuccessful-confirmationDetails-refundSuccessBottomSelection-buttonSelection-buttonReload'
                    copyID='MYB_RETURN_TO_REFUND_MY_FLIGHT'
                    onClick={ () => window.location.reload() }
                    tagName='button'
                  />
                  <TranslatedCopy
                    className='RefundSuccessful-confirmationDetails-refundSuccessBottomSelection-buttonSelection-button'
                    copyID='MYB_EXIT_REFUND'
                    onClick={ () => window.location.href = HomeE4(language, country) }
                    tagName='button'
                  />
                </div>
              </div>
              :
              <>
                { optionSelected === 'AW' &&
                  <TranslatedCopy
                    className='RefundSuccessful-confirmationDetails-accountRedirectBtn'
                    copyID='MYB_SEE_MY_ACCOUNT'
                    tagName='button'
                  />
                }
                { optionSelected === 'Card' &&
                  <TranslatedCopy
                    className='RefundSuccessful-confirmationDetails-accountRedirectBtn'
                    copyID='MYB_EXIT_REFUND'
                    onClick={ () => window.location.href = HomeE4(language, country) }
                    tagName='button'
                  />
                }
              </>
            }
          </div>
        </div>
        :
        <RefundConfirmationViewMobile
          breakpointNewDesign={ breakpointNewDesign }
          cardNumbers={ cardNumbers }
          country={ country }
          currencyOfRefund={ currencyOfRefund }
          date={ date }
          language={ language }
          numberOfDecimalsBE={ numberOfDecimalsBE }
          optionSelected={ optionSelected }
          refundInfoToSalesforce={ refundInfoToSalesforce }
          specialRefund={ specialRefund }
          storefront={ storefront }
          total={ total }
        />
      }
    </Fragment>
  );
};

RefundSuccessful.propTypes = {
  breakpointNewDesign: PropTypes.string,
  country: PropTypes.string,
  fulfillRefundData: PropTypes.object,
  language: PropTypes.string,
  optionSelected: PropTypes.string,
  passengerName: PropTypes.string,
  total: PropTypes.number,
};

const mapStateToProps = (state) => ({
  country: state.LanguageBundle.country,
  fulfillRefundData: state.fulfillRefund.fulfillRefundData,
  language: state.Manage.language,
  refundInfoToSalesforce: state.refundInfoToSalesforce,
  stateStoreFront: state.Manage.stateStoreFront,
  storefront: state.Manage.storefront,
});

const refundSuccessful = connect(mapStateToProps)(RefundSuccessful);

export default withWindow(refundSuccessful);